import { render, staticRenderFns } from "./p08.vue?vue&type=template&id=a916954e&scoped=true&"
import script from "./p08.vue?vue&type=script&lang=js&"
export * from "./p08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916954e",
  null
  
)

export default component.exports